export default __webpack_public_path__ + "static/media/person_pin-24px.39fbda42.svg";